import React from 'react';

const FlagIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(8.000000, 7.000000)'>
        <path d='M1,0 C1.55228475,0 2,0.44771525 2,1 L2,1.88 C3.06,1.44 4.5,1 6,1 C9,1 9,3 11,3 C14,3 15,1 15,1 L15,9 C15,9 14,11 11,11 C8,11 8,9 6,9 C3,9 2,11 2,11 L2,18 L0,18 L0,1 C0,0.44771525 0.44771525,0 1,0 Z' />
      </g>
    </g>
  </svg>
);

export default FlagIcon;
